import { render, staticRenderFns } from "./FileManagementTable.vue?vue&type=template&id=9f68f15c&scoped=true&"
import script from "./FileManagementTable.vue?vue&type=script&lang=js&"
export * from "./FileManagementTable.vue?vue&type=script&lang=js&"
import style0 from "./FileManagementTable.vue?vue&type=style&index=0&id=9f68f15c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f68f15c",
  null
  
)

export default component.exports